import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";

import { danhSachLopTinChiApi } from "../../../api/lop-tin-chi/danhSachLopTinChiApi";
import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import {
  eDanhSachLopTinChiiActionIds,
  IDanhSachLopTinChiExportRequest,
  IDanhSachLopTinChiiActionTypes,
} from "../../action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { rootActions } from "../../actions/rootActions";
import { Download, fileNameWithTime } from "../../../helpers/download";

export function* danhSachLopTinChiSaga(): any {
  yield takeLatest(
    eDanhSachLopTinChiiActionIds.LOAD_CHUA_TONG_HOP_TC_START,
    selectChuaTongHopWorker
  );
  yield takeLatest(eDanhSachLopTinChiiActionIds.EXPORT_START, exportHopWorker);
}

function* selectChuaTongHopWorker(action: IDanhSachLopTinChiiActionTypes): any {
  const res: IBaseRespone = yield call(
    danhSachLopTinChiApi.SelectChuaTongHop,
    action.payload as IDanhSachLopTinChiSelectRequest
  );
  if (res.is_success) {
    yield put(
      rootActions.lopTinChi.danhSachLoptinChi.LOAD_CHUA_TONG_HOP_TC_SUCCESS(
        res.data
      )
    );
  } else {
    yield put(
      rootActions.lopTinChi.danhSachLoptinChi.LOAD_CHUA_TONG_HOP_TC_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* exportHopWorker(action: IDanhSachLopTinChiiActionTypes): any {
  const res: IBaseRespone = yield call(
    danhSachLopTinChiApi.ExportExcel,
    action.payload as IDanhSachLopTinChiExportRequest
  );
  if (res.is_success) {
    Download.Excel(res.data, `${fileNameWithTime("Danh sách lớp tín chỉ")}.xlsx`);
    yield put(
      rootActions.lopTinChi.danhSachLoptinChi.EXPORT_SUCCESS("Thành công")
    );
  } else {
    yield put(
      rootActions.lopTinChi.danhSachLoptinChi.EXPORT_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
